<script lang="ts">
	export let disabled = false;
	export let displayType: 'primary' | 'secondary' | 'danger' | 'outline' | 'alidaSecondary' =
		'primary';
	export let size = 'default';
	export let hidden = false;
	export let type: 'button' | 'submit' | 'reset' = 'button';
	export let margin = '';
	export let backgroundColor = '';
</script>

<button
	class={`${displayType} ${size} ${hidden ? 'hidden' : ''} ${$$props.class}`}
	style={`margin: ${margin}; background-color: ${backgroundColor}`}
	{disabled}
	{type}
	on:click><slot /></button>

<style>
	button {
		display: inline-block;
		position: relative;
		block-size: 36px;
		min-inline-size: 108px;
		padding: 6px;
		border-radius: 2px;
		outline: none;
		color: var(--secondaryHeadlineColor);
		color: white;
		font-size: var(--fontSizeSmaller);
		font-weight: 400;
		text-align: center;
		cursor: pointer;
		user-select: none;
	}

	button:disabled {
		opacity: 0.5;
		cursor: default;
	}

	/* button:focus {

	} */

	.hidden {
		display: none;
	}

	.primary {
		border: 1px solid var(--lightenedPrimaryAccentColor);
		background-color: var(--lightenedPrimaryAccentColor);
	}

	.primary:focus,
	.primary:hover:not(:disabled) {
		border: 1px solid var(--darkenedPrimaryAccentColor);
		background-color: var(--darkenedPrimaryAccentColor);
	}

	.secondary {
		border: 1px solid var(--lightenedSecondaryAccentColor);
		background-color: var(--lightenedSecondaryAccentColor);
	}

	.secondary:focus,
	.secondary:hover:not(:disabled) {
		border: 1px solid var(--darkenedSecondaryAccentColor);
		background-color: var(--darkenedSecondaryAccentColor);
	}

	.danger {
		border: 1px solid var(--lightenedDangerAccentColor);
		background-color: var(--lightenedDangerAccentColor);
	}

	.danger:focus,
	.danger:hover:not(:disabled) {
		border: 1px solid var(--darkenedDangerAccentColor);
		background-color: var(--darkenedDangerAccentColor);
	}

	.outline {
		border: 1px solid black;
		background-color: white;
		color: black;
	}

	.outline:focus,
	.outline:hover:not(:disabled) {
		background-color: rgb(244 246 248);
	}

	.alidaSecondary {
		border: 2px solid #d5d6e0;
		border-radius: 4px;
		background: #fff;
		color: #4a5d6f;
		font-size: 14px;
		font-weight: 700;
	}

	.alidaSecondary:hover {
		border: 2px solid #b1b1ba;
	}

	.alidaSecondary:active {
		border: 2px solid #8c8d94;
	}

	.alidaSecondary:disabled {
		background: #f2f2f2;
	}

	.small {
		min-inline-size: auto;
	}

	.large {
		block-size: 45px;
		line-height: 43px;
	}
</style>
